import { render, staticRenderFns } from "./Genders.vue?vue&type=template&id=666dd233&lang=pug&"
import script from "./Genders.vue?vue&type=script&lang=js&"
export * from "./Genders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports